<template>
    <section class="blue-box">
        <div class="blue-box__inner">
            <div class="blue-box__body">
                <h2
                    v-if="!!title"
                    class="blue-box__title heading-secondary"
                    v-html="$t(title)"
                />
                <p
                    v-for="(text, index) in texts"
                    :key="index"
                    class="blue-box__desc paragraph-primary"
                    v-html="$t(text)"
                />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BlueBoxWithText',
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        texts: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
